import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageTitle, Button } from '@cordata/buffet';
import { format } from 'date-fns';

import Form from '~/components/NavigatorRedirect/Form';
import { UncontrolledTable } from '~/components/common';

const columns = [{
  id: 'updatedDate',
  Header: 'Last Updated',
  accessor: 'attributes.updatedDate',
  Cell: c => (c.value ? format(c.value, 'MM/DD/YYYY') : 'N/A'),
  minWidth: 50,
}, {
  id: 'url',
  Header: 'Url',
  accessor: 'attributes.url',
}, {
  id: 'description',
  Header: 'Description',
  accessor: 'attributes.description',
}];

const defaultSorted = [{
  id: 'updatedDate',
  desc: true,
}];

const NavigatorRedirects = () => {
  const history = useHistory();

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to="/toolbox/navigator-redirects/add"
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Navigator Redirect</span>
          </Button>
        }
      >
        Navigator Redirects
      </PageTitle>

      <UncontrolledTable
        name="navigator-redirects"
        endpoint={{ url: 'admin/navigator-redirect' }}
        defaultSorted={defaultSorted}
        columns={columns}
        getTrProps={(state, rowInfo) => ({
          style: {
            cursor: 'pointer',
          },
          onClick: (e, handleOriginal) => (
            handleOriginal
              ? handleOriginal()
              : history.push(`/toolbox/navigator-redirects/${rowInfo.original.id}`)
          ),
        })}
      />

      <Form />
    </>
  );
};

export default NavigatorRedirects;

